import React from "react";
import { StaticImage } from 'gatsby-plugin-image';
import { Link } from 'gatsby';
import '../../sass/components/_components.footerPerform.scss';

const FooterPerform2023 = () => {
    return (
        <div className="cp-footerPerform">
            <div className="cp-footerPerform__inner">
                <Link className="l-footer2023Perform" to={`/`} data-aos="fade-up">
                    <StaticImage src='../../images/perform2023-footer-logo.svg' alt="Planful" />
                </Link>
                <div className="cp-footerPerform__inner-top l--flex">
                    {/* <div>
                        <h3>If you’re in finance or accounting, you need Planful.</h3>
                        <p>Planful is the pioneer of end-to-end financial close, consolidation, and financial planning & analysis (FP&A) cloud software. Learn how our Continuous Planning platform marries finance’s need for structured planning with the business’ need for dynamic planning.</p>
                    </div> */}
                    {/* <MarketoFormComponent formSubmitMessage="Thank you for your submission" formId="3326" ctaOverride="Register today" /> */}
                    <div>
                        <h3>To reach peak financial performance, you need Planful.</h3>
                        <p>Organizations around the globe use Planful financial performance management cloud software to streamline business-wide planning, budgeting, consolidations, reporting, and analytics and turn financial performance management into a team sport.</p>
                    </div>
                </div>
                <div className="cp-footerPerform__inner-bottom l--flex">
                    <div className="l--left l--flex">
                        <span>@ {new Date().getFullYear()} Planful. All rights reserved</span>
                        <a href="https://planful.com/privacy-policy/" target="_blank">Privacy Policy</a>
                    </div>
                    <div className="l--right">
                        <div className="cp-footer__bottom-social l--social l--flex">
                            <a className="l--genericBorderRadius l--flex" href="https://www.linkedin.com/company/planful-inc" target="_blank" rel="noreferrer" aria-label="LinkedIn, opens in a new tab">
                                <StaticImage src='../../images/perform-footer-linkedin-white.svg' alt="LinkedIn" />
                            </a>
                            <a className="l--genericBorderRadius l--flex" href="https://twitter.com/Planful" target="_blank" rel="noreferrer" aria-label="Twitter, opens in a new tab">
                                <StaticImage src='../../images/perform-footer-twitter-white.svg' alt="Twitter" />
                            </a>
                            <a className="l--genericBorderRadius l--flex" href="https://www.instagram.com/planful_inc/" target="_blank" rel="noreferrer" aria-label="Instagram, opens in a new tab">
                                <StaticImage src='../../images/perform-footer-instagram-white.svg' alt="Instagram" />
                            </a>
                            <a className="l--genericBorderRadius l--flex" href="https://www.facebook.com/PlanfulInc/" target="_blank" rel="noreferrer" aria-label="Facebook, opens in a new tab">
                                <StaticImage src='../../images/perform-footer-facebook-white.svg' alt="Facebook" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FooterPerform2023;